var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',{attrs:{"label":_vm.label,"label-class":"text-truncate"}},[_c('b-form-select',{ref:"select",staticClass:"large-bootstrap-select",attrs:{"options":_vm.tagsOptions(_vm.tags),"multiple":_vm.multiple,"plain":"","disabled":_vm.disabled,"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }